function mongoId(value) {
  if (value == null) return null;
  if (typeof value === 'object' && value._id) return String(value._id);
  return String(value);
}

function sourcesCompatible(childSource, parentSource) {
  if (!childSource || !parentSource) return true;
  return childSource === parentSource;
}

function findParentOuting(outing, outings) {
  const parentMongoId = mongoId(outing.parentId);
  if (parentMongoId && parentMongoId !== String(outing._id)) {
    const byId = outings.find((o) => String(o._id) === parentMongoId);
    if (byId) return byId;
  }
  if (!outing.parent_id) return null;

  const candidates = outings.filter(
    (o) =>
      String(o._id) !== String(outing._id) &&
      o.entity_id === outing.parent_id &&
      sourcesCompatible(outing.source, o.source)
  );
  if (candidates.length === 0) return null;
  if (outing.source) {
    const sameSource = candidates.filter((o) => o.source === outing.source);
    const pool = sameSource.length > 0 ? sameSource : [];
    if (pool.length === 1) return pool[0];
    if (pool.length > 1) {
      const recareas = pool.filter((o) => o.entity_type === 'recarea');
      return recareas.length === 1 ? recareas[0] : recareas[0] || null;
    }
  }
  if (candidates.length === 1) return candidates[0];
  const recareas = candidates.filter((o) => o.entity_type === 'recarea');
  return recareas.length === 1 ? recareas[0] : null;
}

/**
 * Nest campgrounds under recareas using source + parent_id. Shared Going to
 * Camp map ids (entity_id) across tenants must not collapse into one row.
 * Grandchildren flatten onto the recarea, matching the previous dropdown.
 */
export function groupSuggestions(outings = []) {
  const list = outings ?? [];
  const parents = {};

  for (const outing of list) {
    const parent = findParentOuting(outing, list);
    if (!outing.parent_id || !parent) {
      parents[String(outing._id)] = { ...outing, children: [] };
    }
  }

  for (const outing of list) {
    if (!outing.parent_id) continue;
    const parent = findParentOuting(outing, list);
    if (!parent) continue;
    const parentNode = parents[String(parent._id)];
    if (parentNode) {
      parentNode.children.push(outing);
      continue;
    }
    const grand = findParentOuting(parent, list);
    const grandNode = grand && parents[String(grand._id)];
    if (grandNode) grandNode.children.push(outing);
  }

  return Object.values(parents);
}

export function sameNameSelectableChild(parent, children = []) {
  const name = (parent?.name || '').trim().toLowerCase();
  if (!name) return null;
  return (
    children.find(
      (child) =>
        child.entity_type !== 'recarea' &&
        (child.name || '').trim().toLowerCase() === name
    ) || null
  );
}

